import { render, staticRenderFns } from "./DutySettingsButton.vue?vue&type=template&id=7a2e22c0"
import script from "./DutySettingsButton.vue?vue&type=script&lang=ts"
export * from "./DutySettingsButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports